import { observable } from 'mobx';
import Model from 'models/Model';
import { RecertificationInviteStore } from 'stores/RecertificationInviteStore';

export class RecertificationInviteAnalytics extends Model {
  static _store: RecertificationInviteStore;

  @observable id: number;

  @observable event: string;

  @observable event_occured_at: Date;
}
